<div class="flex items-center gap-4 rounded-xl border border-gray-100 bg-white px-5 py-4 shadow-sm">
  @if (loading) {
    <mat-spinner [diameter]="20"></mat-spinner>
  } @else {
    <div
      class="h-5 w-5 shrink-0 rounded-full"
      [style.background-color]="dotColor"
    ></div>
  }
  <div class="min-w-0">
    <p class="font-lato text-xl font-bold text-blue-950">
      {{ value == null ? '…' : value }}
      <span class="text-base font-medium">Circuit{{ value === 1 ? '' : 's' }}</span>
    </p>
    <p class="font-lato text-sm text-brand-muted">{{ title }}</p>
  </div>
</div>
